import React, { useEffect, useState } from 'react';
import placehoderMember from '../../assets/images/Members.jpg';
import placehoderTicket from '../../assets/images/TICKET.jpg';
import infoIcon from '../../assets/images/membershipInfoIcon.svg';
import { Button, Checkbox, Modal } from 'antd';
import dayjs from 'dayjs';
import { useGlobalState } from './GlobalState';
import { CloseOutlined } from '@ant-design/icons';
function MembershipInfo({ info, infoOnly = false }) {
  const [infoVisible, setInfoVisible] = useState(false);
  const [description, setDescription] = useState('');
  const [formState, setFormState] = useGlobalState('formState');
  let placeholder =
    info?.type == 'member' ? placehoderMember : placehoderTicket;
  useEffect(() => {
    if (info?.membership_plans?.length == 1) {
      if (
        (info?.available_stock_limit !== 0 &&
          info?.membership_plans[0]?.available_stock_limit !== 0) ||
        info?.waitlist
      ) {
        setFormState((prevState) => ({
          ...prevState,
          membership_plan_id: info?.membership_plans[0]?.id,
          waitlist:
            info?.available_stock_limit == 0 &&
            info?.membership_plans[0]?.available_stock_limit == 0,
        }));
      }
    }
  }, []);

  return (
    <div>
      <Modal
        open={infoVisible}
        onCancel={() => setInfoVisible(false)}
        width={'min(95%, 30rem)'}
        title={null}
        footer={null}
        closable={false}
        maskClosable
        centered
      >
        <div className='px-20'>
          <div
            aria-label='close'
            onClick={() => {
              setInfoVisible(false);
            }}
            style={{
              position: 'absolute',
              right: 8,
              top: 8,
            }}
          >
            <CloseOutlined />
          </div>
          <div className='gMedium txt-center w-full fs-16 '>{description}</div>
        </div>
      </Modal>
      {info?.membership_plans?.map((plan) => {
        let soldOut = false;
        if (!infoOnly) {
          if (
            info?.available_stock_limit == 0 ||
            plan.available_stock_limit == 0
          ) {
            soldOut = true;
          }
        }
        const getDaySuffix = (day) => {
          if (day > 3 && day < 21) return 'th';
          switch (day % 10) {
            case 1:
              return 'st';
            case 2:
              return 'nd';
            case 3:
              return 'rd';
            default:
              return 'th';
          }
        };
        const calculateFutureDate = (baseDate, number, unit) => {
          return dayjs(baseDate).add(number, unit);
        };

        const formatDate = (date) => {
          const day = dayjs(date).date();
          const month = dayjs(date).format('MMMM');
          const year = dayjs(date).year();

          const dayWithSuffix = `${day}${getDaySuffix(day)}`;

          return `${dayWithSuffix} ${month} ${year}`;
        };
        const number = plan?.ticket_length || 1;
        const unit = plan?.ticket_length_type || 'month'; // can be 'day', 'week', or 'month'
        const baseDate = plan?.ticket_start_date
          ? dayjs(plan?.ticket_start_date, 'DD/MM/YYYY')
          : dayjs();

        const futureDate = calculateFutureDate(baseDate, number, unit);

        const StartTime = plan?.ticket_start_date
          ? formatDate(dayjs(plan?.ticket_start_date, 'DD/MM/YYYY'))
          : formatDate(dayjs());
        const EndTime = plan?.ticket_end_date
          ? formatDate(dayjs(plan?.ticket_end_date, 'DD/MM/YYYY'))
          : formatDate(futureDate);
        const RunTime =
          plan?.ticket_end_date || plan?.ticket_length
            ? `Runs ${StartTime} - ${EndTime}`
            : 'Runs Indefinitely';

        return (
          <>
            <div
              className='membership-info-block'
              style={{
                background:
                  infoOnly || formState?.membership_plan_id == plan.id
                    ? '#ECF7FF'
                    : 'transparent',
              }}
            >
              <div className='row-center'>
                {!infoOnly && (
                  <Checkbox
                    checked={
                      formState?.membership_plan_id &&
                      formState?.membership_plan_id == plan.id
                    }
                    disabled={soldOut && !info?.waitlist}
                    onChange={() => {
                      if (
                        formState?.membership_plan_id &&
                        formState?.membership_plan_id == plan.id
                      ) {
                        setFormState((prevState) => ({
                          ...prevState,
                          membership_plan_id: '',
                          waitlist: soldOut,
                        }));
                      } else {
                        setFormState((prevState) => ({
                          ...prevState,
                          membership_plan_id: plan.id,
                          waitlist: soldOut,
                        }));
                      }
                    }}
                    className='membership-checkbox'
                  />
                )}
                <img
                  src={plan.image ? plan.image : placeholder}
                  width={60}
                  height={60}
                  className={`br5 mg-left-15 ${soldOut ? 'opacity' : ''}`}
                  style={{ objectFit: 'cover' }}
                ></img>
              </div>
              <div
                style={{ flex: 1 }}
                className={`plan-title row-center  ${soldOut ? 'opacity' : ''}`}
              >
                <div className='fs-20 gSemiBold'>
                  <div>{plan?.title}</div>
                  <div className='fs-16 gMedium'>{RunTime}</div>
                </div>
                {plan.description && (
                  <div
                    className={`cp ${soldOut ? 'opacity' : ''}`}
                    onClick={() => {
                      setInfoVisible(true);
                      setDescription(plan?.description);
                    }}
                  >
                    <img
                      className='mg-top-5 mg-left-10'
                      src={infoIcon}
                      alt='info'
                    />
                  </div>
                )}
              </div>
              <div className='fs-18 gBold  justify-center price'>
                <div className={`${soldOut ? 'opacity' : ''}`}>
                  £{plan.price.toFixed(2)}
                </div>
                {soldOut && (
                  <div
                    className='red-bg-400 white gSemiBold w-fit fs-16 pd-left-10 pd-right-10'
                    style={{ borderRadius: 3 }}
                  >
                    SOLD OUT
                  </div>
                )}
              </div>
            </div>
            <div
              className='membership-info-block-mobile'
              style={{
                background:
                  formState?.membership_plan_id == plan.id
                    ? '#ECF7FF'
                    : 'transparent',
              }}
            >
              <div className='row-center'>
                <img
                  src={plan.image ? plan.image : placeholder}
                  width={60}
                  height={60}
                  className={`br5 mg-left-15 ${soldOut ? 'opacity' : ''}`}
                  style={{ objectFit: 'cover' }}
                ></img>
              </div>
              <div
                style={{ flex: 1 }}
                className={`plan-title center txt-center  ${
                  soldOut ? 'opacity' : ''
                }`}
              >
                <div className='fs-24 gSemiBold '>{plan?.title}</div>
                <div className='fs-20 gMedium row-center'>
                  <div>{RunTime}</div>
                </div>
                {plan.description && (
                  <div
                    className={`cp ${soldOut ? 'opacity' : ''}`}
                    onClick={() => {
                      setInfoVisible(true);
                      setDescription(plan?.description);
                    }}
                  >
                    <img className=' mg-left-10' src={infoIcon} alt='info' />
                  </div>
                )}
              </div>
              <div className='fs-40 gBold center  justify-center price'>
                <div className={`${soldOut ? 'opacity' : ''}`}>
                  £{plan.price.toFixed(2)}
                </div>
                {soldOut && (
                  <div
                    className='red-bg-400 fs-22 white gSemiBold w-fit fs-16 pd-left-10 pd-right-10'
                    style={{ borderRadius: 3 }}
                  >
                    SOLD OUT
                  </div>
                )}
              </div>
              {!infoOnly && (
                <Checkbox
                  checked={
                    formState?.membership_plan_id &&
                    formState?.membership_plan_id == plan.id
                  }
                  disabled={soldOut && !info?.waitlist}
                  onChange={() => {
                    if (
                      formState?.membership_plan_id &&
                      formState?.membership_plan_id == plan.id
                    ) {
                      setFormState((prevState) => ({
                        ...prevState,
                        membership_plan_id: '',
                        waitlist: soldOut,
                      }));
                    } else {
                      setFormState((prevState) => ({
                        ...prevState,
                        membership_plan_id: plan.id,
                        waitlist: soldOut,
                      }));
                    }
                  }}
                  className='membership-checkbox xl-checkbox'
                />
              )}
            </div>
          </>
        );
      })}
    </div>
  );
}

export default MembershipInfo;
